import { type PinMessage } from "@design-lab/entities/pinning";
import { MarkdownContent, processTextWithHexCodes } from "@design-lab/shared/ui/MarkdownContent";
import { Loader2 } from "lucide-react";

type PinMessagesProps = {
  messages: PinMessage[];
  isProcessing?: boolean;
  thinkingText?: string | undefined;
  compact?: boolean;
};

export function PinMessages({
  messages,
  isProcessing = false,
  thinkingText,
  compact = false
}: PinMessagesProps) {
  if (messages.length === 0 && !isProcessing) {
    return null;
  }

  return (
    <div className={`flex flex-col ${compact ? "gap-2" : "gap-4"} ${compact ? "" : "pl-1"}`}>
      {messages.map(msg => (
        <div key={msg.id} className={`flex flex-col text-sm ${compact ? "gap-0.5" : "gap-1"}`}>
          <span
            className={`text-[10px] font-bold uppercase ${msg.role === "user" ? "text-gray-400" : "text-blue-700"}`}
          >
            {msg.role === "user" ? "ME" : "REDRAW ASSISTANT"}
          </span>
          {msg.role === "ai" ? (
            <MarkdownContent content={msg.content} />
          ) : (
            <div className="whitespace-pre-wrap text-gray-800">
              {processTextWithHexCodes(msg.content)}
            </div>
          )}
        </div>
      ))}
      {isProcessing && (
        <div className={`flex flex-col ${compact ? "gap-0.5 text-xs" : "gap-1 text-sm"}`}>
          <span
            className={`font-bold uppercase text-blue-700 ${compact ? "text-[9px]" : "text-[10px]"}`}
          >
            REDRAW ASSISTANT
          </span>
          <div className={`flex items-center ${compact ? "gap-1.5" : "gap-2"}`}>
            <Loader2
              className={`shrink-0 animate-spin text-blue-600 ${compact ? "h-3.5 w-3.5" : "h-4 w-4"}`}
            />
            <span className={`text-gray-500 ${compact ? "text-xs" : "text-sm"}`}>
              {thinkingText || "Thinking..."}
            </span>
          </div>
        </div>
      )}
    </div>
  );
}
